export class OpenPay {
    
    idClient: string;

    constructor(){
        this.idClient = this.idClient;
    }
}